var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 20,
    viewBox: "0 0 63 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8456 0.882812V6.35831L18.4758 5.09895L20.1156 10.0817L14.5948 11.1768L18.3118 16.5428L14.0481 19.8828L10.0578 14.4073L6.06748 19.8828L1.74918 16.5428L5.52086 11.2315L0 10.0817L1.63986 5.09895L7.16072 6.35831L7.27005 0.882812H12.8456Z",
    fill: "#2377FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0378 0.882812V6.35831L39.668 5.09895L41.3078 10.0817L35.787 11.1768L39.504 16.5428L35.2403 19.8828L31.25 14.4073L27.2597 19.8828L22.9414 16.5428L26.7131 11.2315L21.1922 10.0817L22.8321 5.09895L28.3529 6.35831L28.4622 0.882812H34.0378Z",
    fill: "#2377FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.23 0.882812V6.35831L60.8602 5.09895L62.5 10.0817L56.9791 11.1768L60.6962 16.5428L56.4325 19.8828L52.4422 14.4073L48.4519 19.8828L44.1336 16.5428L47.9053 11.2315L42.3844 10.0817L44.0243 5.09895L49.5451 6.35831L49.6544 0.882812H55.23Z",
    fill: "#2377FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9f3c7b06244c7400ab7d1cf6fe487b53.svg";
export { ForwardRef as ReactComponent };